/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Lookup } from '../models/lookup';

@Injectable({
  providedIn: 'root',
})
export class IndustriesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation industriesGet
   */
  static readonly IndustriesGetPath = '/v1/admin/billing/industries';

  /**
   * Returns a list of supported industries defined in plan codes.
   * The list is populated from a csv file. For more details please see
   * PlanCodesController.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `industriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  industriesGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<Lookup>>> {

    const rb = new RequestBuilder(this.rootUrl, IndustriesService.IndustriesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Lookup>>;
      })
    );
  }

  /**
   * Returns a list of supported industries defined in plan codes.
   * The list is populated from a csv file. For more details please see
   * PlanCodesController.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `industriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  industriesGet(params?: {
  }): Observable<Array<Lookup>> {

    return this.industriesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Lookup>>) => r.body as Array<Lookup>)
    );
  }

}
